import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token'


export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function setRefreshToken(refreshToken) {
  Cookies.set('refreshToken', refreshToken); // 设置过期时间为1小时
}

// 获取 Refresh Token
export function getStoredRefreshToken() {
  return Cookies.get('refreshToken');
}


// 存储租户号 Tenant number
export function setTenantNumber(tenantNumber) {
  Cookies.set('tenantNumber', tenantNumber); // 设置过期时间为1小时
}

// 获取 Tenant Number
export function getStoredTenantNumber() {
  return Cookies.get('tenantNumber');
}

//
